import { useContext, useEffect, useState } from "react";
import "./index.css";
import { filterDataContext } from "../../App";
import { convertTicketFormat, getDayFromDate } from "../../utils/func";
import { EMPTY_CART_LIST_API } from "../../APIs";

const QuantityCheckPopUp = ({ data, setState, funcToCall, callReserve, handleReserveAgain }) => {
    const { reserveTicket, reservationLoader, setReserVationData, fetchCartList, setCartData , setStockAvailabilityData} = useContext(filterDataContext);
    const [convertedData, setConvertedData] = useState([]);

    useEffect(() => {
        if (!Array.isArray(data)) return;

        const updateReservationData = data
            .map((item) => {
                const hasAvailableKey = "available" in (item?.error?.error || {});
                const quantity = hasAvailableKey ? item?.error?.error?.available : item?.error?.quantity;

                return {
                    ticket_id: item.details?.ticket_id,
                    quantity,
                    categoryId: item?.details?.category_id,
                    ticketName: daysGrouped(item?.details),
                };
            })
            .filter((item) => item.quantity > 0);

        setConvertedData(updateReservationData);
    }, [data]);

    const handleClose = () => {
        setState(false);
        setStockAvailabilityData([])
        if (funcToCall) funcToCall();
    };

    const daysGrouped = (items) => {
        const { eventdays, ticket_validfrom } = items;
        return eventdays === "singleday"
            ? getDayFromDate(ticket_validfrom)
            : convertTicketFormat(eventdays);
    };


    const hanldeClearCart = async () => {
        try {
            const response = await EMPTY_CART_LIST_API()
            if (response && response?.status) {
                fetchCartList()
                setCartData([])
                setReserVationData([])
            }
        } catch (error) {
            console.log(error, "clear_cart_list")
        }
    }


    const handleContinueToReserve = () => {
        if (convertedData?.length > 0) {
            setReserVationData(convertedData);
            if (handleReserveAgain) handleReserveAgain(convertedData);
            if (callReserve) reserveTicket(convertedData);
        } else {
            hanldeClearCart()
        }
        handleClose();
    };


    return (
        <div className="popup-container">
            <div className="popup-content">
                {convertedData?.length > 0 ? (
                    data.map((item, index) => {
                        const eventDetails = item?.details?.event_event;
                        const errorDetail = item?.error?.error?.detail;
                        const hasAvailableKey = "available" in (item?.error?.error || {});
                        const quantity = hasAvailableKey ? item?.error?.error?.available : item?.error?.quantity;
                        if (!item?.error?.error) return null;
                        return (
                            <div key={index} className="event-section">
                                <h2 className="event-name">{eventDetails?.event_name}</h2>
                                <div className="ticket-card">
                                    <div className="ticket-header">
                                        <h3>{item?.details?.ticket_title}</h3>
                                        <p><strong>Venue:</strong> {eventDetails?.venue_name}</p>
                                    </div>
                                    <div className="showAvailabilityStock">
                                        <p>Stock for this has changed</p>
                                        <div className="stock-info">
                                            <h2>Available Stock: {quantity}</h2>
                                            <h2>Requested Stock: {item?.error?.error?.quantity}</h2>
                                        </div>
                                    </div>
                                    {errorDetail && <p className="error-text">{errorDetail}</p>}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <p className="no-stock-message">
                        Unfortunately, the selected tickets are no longer available.
                        Please try selecting different options or check back later.
                    </p>
                )}
            </div>

            <div className="popup-actions">
                {
                    convertedData?.length > 0 ?
                        <>
                            <button onClick={handleContinueToReserve} disabled={reservationLoader}>
                                Continue with Available Stock
                            </button>
                            <button onClick={handleClose}>Discard Cart</button>
                        </>
                        :
                        <button onClick={handleContinueToReserve} disabled={reservationLoader}>
                            okay
                        </button>
                }
            </div>
        </div>
    );
};

export default QuantityCheckPopUp;
